export default class UtilResponseException {

    /**
     *
     * @param responseException
     * @param delimiter
     * @returns {string}
     */
    static getMessage(responseException, delimiter = '<br>') {
        const {response = {}} = responseException;
        const {status = -1, data: {data = {}}} = response;
        if(status === 403){
            return 'Нет доступа к данной функции';
        }

        if(status === 400){
            const keys = Object.keys(data);

            const errors = keys.reduce((acc, key) => {
                return [...acc, ...data[key]]
            }, [])

            return errors.join(delimiter);
        }

        return 'Что то пошло не так';
    }
}
